var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('TheTopbarSwitchMenu',{attrs:{"items":_vm.items,"selected-item":_vm.currentScope,"subheader":_vm.$t('seeAs'),"aria-label":_vm.$t('seeAs')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }